import type { CSSObject } from '@emotion/react'
import { FocusIndicator, Size, Spacing } from '@opallabs/gem'
import type { WithRequiredTheme } from '@opallabs/lapidary'

// This file has styling for using Kuiper `<Menu>` in combination with Lapidary
// `<Popover>`--controlled by the `disableKuiperStyling` prop.

type ContainerProps = WithRequiredTheme
export const container = ({ theme }: ContainerProps): CSSObject => ({
  borderRadius: Size.Rounding,
  display: 'flex',
  flexDirection: 'column',
  // This is intended to be dynamic--the block end should be 64px (16 grid
  // units) from the end of the viewport.
  maxBlockSize: Spacing.XL * 6.25,
  maxInlineSize: Spacing.XL * 6.25,
  // This has to be set because items in `<VirtualList>` don't affect the
  // dimensions of parent elements, so `<VirtualList>` (and thus `<Menu>`) have
  // the implicit inline-size of `0`.
  minInlineSize: Spacing.XL * 4.5,
  overflow: 'auto',

  '&:focus': {
    ...FocusIndicator[theme],
  },
})
